import ConnectedPlayerCell from './PlayerCell';

export default ConnectedPlayerCell;



// WEBPACK FOOTER //
// ./src/app/components/DataTable/PlayerCell/index.js